import React, { useEffect, useRef } from 'react';
import { Scrollbars } from 'rc-scrollbars';
import prevDataIcon from '../../../images/prevData.png';
import nextDataIcon from '../../../images/nextData.png';
import nextDataDisabledIcon from '../../../images/nextData_disabled.png'
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { API_URL } from '../../../config/constants';
import moment from 'moment-timezone';
import { idKey, isFullListSelected } from './selectionUtils';

function DataListMenu({ dDs, monitData, selSensorIdx, selDataIdx, setSelDataIdx, getPrevData, getMoreData, isLastData, chkedData, setChkedData, onRowClick, listScrollRequest }) {
    const scrollbarRef = useRef();

    const companyInitial = 'K';
    const sensorTypeInitial = 'D';
    // 추후 계정 정보에서 company 컬럼 데이터 받아오도록 수정要
    // company 정보를 기준으로 rawData 테이블을 선별해 받아옴
    const company = "세동산업";

    const onCheckAll = (e) => {
        e.preventDefault();
        const allIdNos = (monitData ?? []).map((el) => el.dataId);
        if (isFullListSelected(monitData, chkedData)) {
            setChkedData([]);
        } else {
            setChkedData([...allIdNos]);
        }
    }

    const handleDownloadRawBundle = (e) => {
        e.preventDefault();
        makeRawBundle()
    }

    function makeCsvData(selData) {
        console.log(selData)
        const grpNames = dDs?.indexName ?? [];
        const grpDims = dDs?.indexDim ?? [];
        const defaultUnit = grpDims[0];
        const headerCols = grpNames.map((name, idx) => {
            const unit = grpDims[idx] ?? defaultUnit;
            return unit != null && String(unit).trim() !== '' ? `${name}(${unit})` : `${name}`;
        });
        const labelArr = ["time", ...headerCols];
        const dataArr = selData.split(';');
        dataArr.pop();
        const arrayConvertedDataArr = dataArr.map(el => el.split(','));
        const mergedArr = [labelArr, ...arrayConvertedDataArr];
        return mergedArr;
    }


    async function makeRawBundle() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getRawBundle`, {
            isAbout: dDs["tableName"],
            dataIds: chkedData,
        });

        const { success, datum } = response.data;
        if (!success) {
            window.alert('파일 저장에 실패하였습니다. 잠시 후 다시 시도해주세요.')
            return;
        }

        const zip = new JSZip();

        function csvEscape(v) {
            if (v == null) return '';
            const s = String(v);
            if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
            return s;
        }

        function toCsvText(rows) {
            return rows.map(row => row.map(csvEscape).join(',')).join('\n');
        }

        function rawDateToExportStem(dateStr, dataId) {
            if (dateStr == null) {
                return `${moment().format('YYMMDD_HHmmss')}_${dataId}`;
            }
            const s = String(dateStr);
            if (s.length >= 15) {
                const y = s.substr(0, 4);
                const mo = s.substr(4, 2);
                const d = s.substr(6, 2);
                const h = s.substr(9, 2);
                const mi = s.substr(11, 2);
                const sec = s.substr(13, 2);
                const m = moment.tz(
                    `${y}-${mo}-${d} ${h}:${mi}:${sec}`,
                    'YYYY-MM-DD HH:mm:ss',
                    true,
                    'Asia/Seoul'
                );
                if (m.isValid()) return m.format('YYMMDD_HHmmss');
            }
            if (s.length === 8 && /^\d{8}$/.test(s)) {
                const m = moment.tz(
                    `${s.substr(0, 4)}-${s.substr(4, 2)}-${s.substr(6, 2)}`,
                    'YYYY-MM-DD',
                    true,
                    'Asia/Seoul'
                );
                if (m.isValid()) return `${m.format('YYMMDD')}_000000`;
            }
            const m = moment(dateStr);
            return m.isValid() ? m.format('YYMMDD_HHmmss') : `${moment().format('YYMMDD_HHmmss')}_${dataId}`;
        }

        const usedCsvNames = new Map();
        datum.forEach((item) => {
            let stem = rawDateToExportStem(item.date, item.dataId);
            let base = `${companyInitial}${sensorTypeInitial}${stem}`;
            let filename = `${base}.csv`;
            if (usedCsvNames.has(filename)) {
                const next = usedCsvNames.get(filename) + 1;
                usedCsvNames.set(filename, next);
                filename = `${base}_${next}.csv`;
            } else {
                usedCsvNames.set(filename, 0);
            }
            console.log(item)
            // ✅ makeCSVData는 배열(rows)을 리턴
            const rows = makeCsvData(item["data"]);
            const csvText = '\uFEFF' + toCsvText(rows); // BOM 포함(엑셀 한글 깨짐 방지)
            zip.file(filename, csvText);
        });

        const zipBlob = await zip.generateAsync({ type: "blob" });
        const zipName = `${companyInitial}${sensorTypeInitial}_${moment().format("YYMMDD_HHmmss")}.zip`;
        saveAs(zipBlob, zipName);
    }


    useEffect(() => {
        scrollbarRef.current?.scrollToTop();
    }, [selSensorIdx]);

    // 최초 진입·필터/탭 등으로 목록이 갈아끼워질 때만 맨 위 (토큰·mode 변경 시). selDataIdx 변경과는 분리.
    useEffect(() => {
        if (!listScrollRequest || listScrollRequest.token === 0) return;
        if (listScrollRequest.mode !== 'top') return;
        const sb = scrollbarRef.current;
        if (!sb?.view) return;
        sb.scrollToTop();
    }, [listScrollRequest?.token, listScrollRequest?.mode]);

    // 선택 행이 보이도록 스크롤 (클릭만 바뀐 경우에도 동작, mode가 'top'으로 남아 있어도 동작).
    useEffect(() => {
        if (!listScrollRequest || listScrollRequest.token === 0) return;
    
        // 사용자 직접 클릭이면 자동 스크롤 금지
        if (listScrollRequest.mode === 'user-click') return;
        console.log("선택", listScrollRequest.mode)
    
        // 자동 매칭일 때만 선택행 스크롤 허용
        if (listScrollRequest.mode !== 'auto-match' && listScrollRequest.mode !== 'detail-match') return;
    
        const sb = scrollbarRef.current;
        if (!sb?.view) return;
        if (selDataIdx < 0 || !(monitData?.length > 0)) return;
    
        requestAnimationFrame(() => {
            const view = sb.view;
            if (!view) return;
    
            const lis = view.querySelectorAll('.dataTitleLi');
            const li = lis[selDataIdx];
            if (!li) return;
    
            const viewTop = view.scrollTop;
            const viewBottom = viewTop + view.clientHeight;
            const liTop = li.offsetTop;
            const liBottom = liTop + li.offsetHeight;
    
            // 이미 화면 안에 보이면 안 움직임
            const isVisible = liTop >= viewTop && liBottom <= viewBottom;
            if (listScrollRequest.mode !== 'detail-match' && isVisible) return;
    
            const viewH = view.clientHeight;
            const h = li.offsetHeight;
            const target = Math.max(0, liTop - Math.max(0, (viewH - h) / 2));
            sb.scrollTop(target);
        });
    }, [listScrollRequest?.token, listScrollRequest?.mode, selDataIdx, monitData?.length]);

    const selectedKeySet = new Set(chkedData.map(idKey));

    return (

        <div className='dataTitleListArea'>
            <div className='dlBtnsArea'>
                {/* 상단 버튼 제거(숨김) */}
                
            </div>
            {
                monitData?.length > 0 &&
                <React.Fragment>
                    <div className='selectDataTitle'>데이터 선택</div>
                    {/* <div className='dataTitleContainer' id='scrollArea'> */}
                    <button className='getPrevDataBtn' onClick={getPrevData}>
                        <img src={prevDataIcon} alt='이전' />
                    </button>
                    <Scrollbars className='dataTitleContainer' id='scrollArea' style={{ width: '255px', height: 'calc(100% - 38px - 62px)' }} ref={scrollbarRef}>
                        <ul className='dataTitleUl'>
                            {
                                monitData?.map((el, idx, arr) => {
                                    const isSelected = selectedKeySet.has(idKey(el.dataId));
                                    const date = el.date;
                                    return (
                                        <li className='dataTitleLi' key={idx}>
                                            <button
                                                className={isSelected ? 'dataTitleBtn selected' : 'dataTitleBtn'}
                                                onClick={e => {
                                                    e.preventDefault();
                                                    if (!e.shiftKey && !e.ctrlKey && !e.metaKey) {
                                                        setSelDataIdx(idx);
                                                    }
                                                    onRowClick(e, idx, el.dataId);
                                                }}
                                            >
                                                {
                                                    `${date.substr(0, 4)}년 ${parseInt(date.substr(4, 2))}월 ${parseInt(date.substr(6, 2))}일 ${date.substr(9, 2)}:${date.substr(11, 2)}:${date.substr(13, 2)}`
                                                }
                                            </button>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </Scrollbars>
                    {/* </div> */}
                    <button className='getNextDataBtn' onClick={getMoreData} disabled={isLastData} ><img src={isLastData ? nextDataDisabledIcon : nextDataIcon} alt='이후' /></button>
                </React.Fragment>
            }
        </div>
    );
}

export default React.memo(DataListMenu);
